import { joinURL } from 'ufo';

type UseVideoSrcReturn = {
    getVideoSrc: (src: string) => string;
};

export const useVideoSrc = (): UseVideoSrcReturn => {
    const baseURL = useRuntimeConfig().public.cdnMediaBaseUrl;

    return {
        getVideoSrc: src => joinURL(baseURL, `${src}.webm`),
    };
};
